import * as React from 'react'
import * as ReactDOM from 'react-dom'
import registerServiceWorker from './registerServiceWorker'
import {compose, Store} from 'redux'
import {init, reducer} from './App/Reducer'
import './style.css'
import * as injectTapEventPlugin from 'react-tap-event-plugin'
import {Provider} from 'react-redux'
import {createLoopStore} from '@mazechazer/redux-loop'
import {Action} from './App/Actions'
import {AppContainer} from './App/View'
import {State} from './App/State'

// tslint:disable
const composeEnhancers =
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
// tslint:enable

const store = createLoopStore<State, Action>(
    reducer,
    init(localStorage.getItem('session'), window.location.hash),
    composeEnhancers())

window.addEventListener(
    'hashchange',
    () => {
        const action: Action = {
            type: 'NavigationAction',
            hash: window.location.hash
        }
        store.dispatch(action)
    },
    false)

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin()

ReactDOM.render(
    // tslint:disable-next-line
    <Provider store={store as Store<any>}>
        <AppContainer/>
    </Provider>,
    document.getElementById('root') as HTMLElement
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx